<section class="welcome-section">
  <ose-endless-line class="black-background" type="black"> </ose-endless-line>
  <ose-endless-line class="white-background" type="white"> </ose-endless-line>
  <div class="netfone-container">
    <div class="title-content-wrapper">
      <span class="d-inline-block"></span>
      <div class="title-wrapper">
        <h1 class="title-bar">Legyen a netfone</h1>
        <h1 class="title-bar secondary">A te új mobilszolgáltatód!</h1>
      </div>
      <h3 class="motto-1">{{ user.nev }}</h3>
      <div class="icon-wrapper">
        <div class="shop-detail-wrapper">
          <img src="assets/images/vea-site/icon-phone.svg" alt="" />
          <a class="shop-detail" [href]="'tel:' + user.telefonszam">{{ user.telefonszam }}</a>
        </div>
        <div class="shop-detail-wrapper">
          <img src="assets/images/vea-site/icon-locaion.svg" alt="" />
          <a class="shop-detail" [href]="'//maps.google.com/?q=' + user.telepules">{{ user.telepules }}</a>
        </div>
        <div class="shop-detail-wrapper">
          <img src="assets/images/vea-site/icon-email.svg" alt="" />
          <a class="shop-detail" [href]="'mailto:' + user.email">{{ user.email }}</a>
        </div>
        <div class="shop-detail-wrapper" *ngIf="user.website">
          <img src="assets/images/vea-site/icon-website.svg" alt="" />
          <a class="shop-detail" [href]="getWebsiteUrl(user.website)">{{ user.website }}</a>
        </div>
      </div>
      <div class="image-wrapper">
        <img [src]="profileImgSrc" [alt]="user.nev" (error)="onFailLoadImage()" class="title-image" />
      </div>
    </div>
  </div>
</section>

<section class="welcome-section-mobile">
  <div class="image-wrapper">
    <img [src]="profileImgSrc" [alt]="user.nev" (error)="onFailLoadImage()" class="title-image" />
  </div>
  <div class="netfone-container black-background-container" id="black-background-container">
    <ose-endless-line class="black-background" type="black"></ose-endless-line>
    <h3 class="title-bar">Legyen a netfone</h3>
    <h3 class="title-bar secondary">A te új mobilszolgáltatód</h3>
  </div>
  <div class="netfone-container white-background-container">
    <ose-endless-line class="white-background" type="white"></ose-endless-line>
    <h3 class="motto-1">{{ user.nev }}</h3>
  </div>
</section>

<section class="mobile-icon-wrapper-section">
  <div class="netfone-container">
    <div class="icon-wrapper">
      <div class="shop-detail-wrapper">
        <img src="assets/images/vea-site/icon-phone.svg" alt="" />
        <a class="shop-detail" [href]="'tel:' + user.telefonszam">{{ user.telefonszam }}</a>
      </div>
      <div class="shop-detail-wrapper">
        <img src="assets/images/vea-site/icon-locaion.svg" alt="" />
        <span class="shop-detail">{{ user.telepules }}</span>
      </div>
      <div class="shop-detail-wrapper">
        <img src="assets/images/vea-site/icon-email.svg" alt="" />
        <a class="shop-detail" [href]="'mailto:' + user.email">{{ user.email }}</a>
      </div>
      <div class="shop-detail-wrapper" *ngIf="user.website">
        <img src="assets/images/vea-site/icon-website.svg" alt="" />
        <a class="shop-detail" [href]="getWebsiteUrl(user.website)">{{ user.website }}</a>
      </div>
    </div>
  </div>
</section>
<div id="scroll-here"></div>
<section class="packages-mobile-section">
  <div class="light-orange-design-circle"></div>
  <div class="dark-orange-design-circle"></div>
  <div class="section-title-wrapper">
    <div class="netfone-container">
      <h1 class="title">Nézd meg akciós csomagajánlatainkat</h1>
    </div>
  </div>
  <div class="netfone-container">
    <div class="flex-row justify-content-center">
      <h3 class="subtitle">10 hónap hűséggel!</h3>
    </div>
    <div class="package-wrapper">
      <ose-large-mobile-package
        *ngFor="let packageItem of packages"
        [packageDetails]="packageItem"
        (buttonClicked)="order($event)"
        [displayAsPillOnMobile]="true"
      ></ose-large-mobile-package>
    </div>
  </div>
</section>

<section class="features-section">
  <div class="netfone-container">
    <div class="features-wrapper">
      <img src="assets/images/vea-site/icon-simcard.webp" alt="" class="sim" />
      <p class="feature-description">Ügyintézés és SIM átvétel a boltban.</p>
    </div>
  </div>
</section>

<section class="packages-section">
  <div class="light-orange-design-circle"></div>
  <div class="dark-orange-design-circle"></div>
  <div class="section-title-wrapper">
    <div class="netfone-container">
      <h1 class="title">Mások ezeket a csomagokat választották</h1>
    </div>
  </div>
  <div class="netfone-container">
    <div class="flex-row justify-content-start">
      <h3 class="subtitle">Kedvelt csomagjaink, 10 hónap hűséggel!</h3>
    </div>
    <div class="package-wrapper">
      <ose-large-mobile-package
        *ngFor="let packageItem of packages"
        [packageDetails]="packageItem"
        (buttonClicked)="order($event)"
        [displayAsPillOnMobile]="true"
      ></ose-large-mobile-package>
    </div>
  </div>
</section>

<ose-all-packages [data]="allServicesData" [backgroundColor]="'tan-3'" *ngIf="allServicesData"></ose-all-packages>

<section class="reason-section">
  <div class="section-title-wrapper">
    <ose-endless-line type="black" class="black-background"></ose-endless-line>
    <div class="netfone-container">
      <div class="title">5 JÓ OK AMIÉRT ÉRDEMES MINKET VÁLASZTANOD ÚJ MOBILSZOLGÁLTATÓDNAK</div>
    </div>
  </div>
  <div class="mobile-reason-wrapper netfone-container">
    <div class="reason">
      <div class="title-wrapper">
        <img src="assets/images/argarancia_ikon_sarga.svg" alt="" />
        <h1 class="title">ÁRGARANCIA</h1>
      </div>
      <div class="description">
        Mi is hűséget fogadunk Neked és biztosítunk Téged arról, hogy a piacon elérhető publikus árakhoz képest az
        árelőnyt mindig fenntartjuk.
      </div>
    </div>
    <div class="reason">
      <div class="title-wrapper">
        <img src="../../../../assets/images/ikon_lefedettseg_black_no_text.svg" alt="" />
        <h1 class="title">ORSZÁGOS LEFEDETTSÉG</h1>
      </div>
      <div class="description">Magyarország egész területén 98%-os lefedettséget biztosítunk ügyfeleink számára.</div>
    </div>
    <div class="reason">
      <div class="title-wrapper">
        <img src="../../../../assets/images/ikon_nem_csak_multunk_1_black_no_text.svg" alt="" />
        <h1 class="title">NEM CSAK MÚLTUNK, JÖVŐNK IS VAN</h1>
      </div>
      <div class="description">
        A Netfone Telecom több mint 10 év, a távközlésben szerzett tapasztalattal büszkélkedhet. Itt nem állunk meg,
        célunk és törekvésünk egy több generációs telekommunikációs vállalat felépítése. Rád is számítunk az úton.
      </div>
    </div>
    <div class="reason">
      <div class="title-wrapper">
        <img src="../../../../assets/images/ikon_szamhordozas_black_no_text.svg" alt="" />
        <h1 class="title">MEG AKAROD TARTANI A RÉGI MOBILSZÁMOD?</h1>
      </div>
      <div class="description">
        Gyere át hozzánk, legyél Te is Netfone-os és ha akarod tartsd meg a régi telefonszámod, mi mindent villámgyorsan
        elintézünk.
      </div>
    </div>
    <div class="reason">
      <div class="title-wrapper">
        <img src="../../../../assets/images/ikon_mobilszolgaltato_1_black_no_text.svg" alt="" />
        <h1 class="title">MOBILSZOLGÁLTATÓ VAGYUNK</h1>
      </div>
      <div class="description">
        Büszkék vagyunk rá, hogy nem flotta vagyunk hanem valódi Mobilszolgáltató. Hogyan lehet ez? Pontosan úgy ahogy
        több internet vagy vezetékes telefonszolgáltató is működik. Kötöttünk egy Mobil Nagykereskedelmi szerződést két
        nagy mobilszolgáltatóval és fejlesztettünk egy saját mobilplatformot amivel vezéreljük a hálózatokat.
      </div>
    </div>
  </div>
  <div class="pc-reason-wrapper netfone-container">
    <div class="reason-column-wrapper">
      <div class="reason-column">
        <div class="reason">
          <div class="reason">
            <div class="title-wrapper">
              <img src="assets/images/argarancia_ikon_sarga.svg" alt="" />
              <h1 class="title">ÁRGARANCIA</h1>
            </div>
            <div class="description">
              Mi is hűséget fogadunk Neked és biztosítunk Téged arról, hogy a piacon elérhető publikus árakhoz képest az
              árelőnyt mindig fenntartjuk.
            </div>
          </div>
          <div class="title-wrapper">
            <img src="../../../../assets/images/ikon_lefedettseg_black_no_text.svg" alt="" />
            <h1 class="title">ORSZÁGOS LEFEDETTSÉG</h1>
          </div>
          <div class="description">
            Magyarország egész területén 98%-os lefedettséget biztosítunk ügyfeleink számára.
          </div>
        </div>
        <div class="reason">
          <div class="title-wrapper">
            <img src="../../../../assets/images/ikon_nem_csak_multunk_1_black_no_text.svg" alt="" />
            <h1 class="title">NEM CSAK MÚLTUNK, JÖVŐNK IS VAN</h1>
          </div>
          <div class="description">
            A Netfone Telecom több mint 10 év, a távközlésben szerzett tapasztalattal büszkélkedhet. Itt nem állunk meg,
            célunk és törekvésünk egy több generációs telekommunikációs vállalat felépítése. Rád is számítunk az úton.
          </div>
        </div>
      </div>
      <div class="reason-column">
        <div class="reason">
          <div class="title-wrapper">
            <img src="../../../../assets/images/ikon_szamhordozas_black_no_text.svg" alt="" />
            <h1 class="title">MEG AKAROD TARTANI A RÉGI MOBILSZÁMOD?</h1>
          </div>
          <div class="description">
            Gyere át hozzánk, legyél Te is Netfone-os és ha akarod tartsd meg a régi telefonszámod, mi mindent
            villámgyorsan elintézünk.
          </div>
        </div>
        <div class="reason">
          <div class="title-wrapper">
            <img src="../../../../assets/images/ikon_mobilszolgaltato_1_black_no_text.svg" alt="" />
            <h1 class="title">MOBILSZOLGÁLTATÓ VAGYUNK</h1>
          </div>
          <div class="description">
            Büszkék vagyunk rá, hogy nem flotta vagyunk hanem valódi Mobilszolgáltató. Hogyan lehet ez? Pontosan úgy
            ahogy több internet vagy vezetékes telefonszolgáltató is működik. Kötöttünk egy Mobil Nagykereskedelmi
            szerződést két nagy mobilszolgáltatóval és fejlesztettünk egy saját mobilplatformot amivel vezéreljük a
            hálózatokat.
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="map-section">
  <div class="netfone-container">
    <h4 class="subtitle">Keresd meg a hozzád legközelebbi értékesítési pontunkat</h4>
    <div class="map-container">
      <ose-reseller-map [mapType]="mapTypeEnum.RESELLER_ONLY"></ose-reseller-map>
    </div>
  </div>
</section>

<section class="share-section">
  <div class="light-orange-design-circle-1"></div>
  <div class="light-orange-design-circle-2"></div>
  <div class="light-orange-design-circle-3"></div>
  <div class="netfone-container share-wrapper">
    <h3 class="share-description">
      Együtt óvjuk a környezetet, ezért az árainkat úgy kalkuláltuk, hogy a számlát e-mailben küldjük és nem postán.
      E-pack kedvezmény nélkül a havi díjak minden szolgáltatás csomag esetén egységesen automatikusan 700 Ft-al
      emelkednek. <br />
      Az árak tartalmazzák az Általános Forgalmi Adót. A tájékoztatás nem teljeskörű.
    </h3>
    <ose-global-share-button
      [shareText]="'Ha tetszett, szólj a barátaidnak is'"
      [shareClass]="'border-radius-10'"
    ></ose-global-share-button>
  </div>
</section>
